import {
  all,
  call,
  delay,
  fork,
  put,
  takeLatest,
  takeLeading,
} from 'redux-saga/effects';
import { toastError } from 'src/common/helpers/Notifications';
import TextConstants from 'src/common/helpers/TextConstants';
import ApiConstants from '../../../common/helpers/ApiConstants';
import * as requests from '../../../common/helpers/HTTPRequest';
import {
  clearStorageWithException,
  setUserInfo,
  setUserRefreshToken,
  setUserToken,
} from '../../../common/helpers/StorageUtils';
import {
  loginActions,
  performLoginCleanState,
  performLoginError,
  performLoginSuccess,
  performLogoutCleanState,
  performLogoutError,
  performLogoutSuccess,
  performTokenExpiredSuccess,
} from './actions';

function* loginUser({ payload }) {
  try {
    const requestBody = { ...payload };
    const url = `${ApiConstants.BASE_URL_V2}${ApiConstants.LOGIN_URL}`;
    const apiRes = yield call(requests.postRequest, url, requestBody, false);
    if (apiRes) {
      // store user token
      setUserToken(apiRes.idToken);
      setUserRefreshToken(apiRes.refreshToken);
      // get user profile
      const user = yield call(
        requests.getRequest,
        `${ApiConstants.BASE_URL}${ApiConstants.PROFILE}`,
        {}
      );
      setUserInfo(user);
      yield put(performLoginSuccess(apiRes));
    } else {
      yield put(performLoginError({ message: 'Oops! something went wrong!' }));
    }
  } catch (error) {
    console.log(error);
    yield put(performLoginError({ message: error?.message || '' }));
  } finally {
    yield delay(2000);
    yield put(performLoginCleanState());
  }
}

function* logoutUser({ payload }) {
  try {
    const { isTokenExpired } = payload;

    // clear all from storage except dataFrame and dataViewDataFrame (client requested to keep data frame settings)
    clearStorageWithException(['dataFrame', 'dataViewDataFrame']);

    if (isTokenExpired) {
      yield put(
        performTokenExpiredSuccess(TextConstants.Common.SessionExpired)
      );
    } else {
      yield put(
        performLogoutSuccess(TextConstants.Common.loggedOutSuccessfully)
      );
    }
  } catch (error) {
    yield put(performLogoutError());
  } finally {
    yield delay(3500);
    yield put(performLogoutCleanState());
  }
}

function* getUserProfileSaga({ callback }) {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.PROFILE}`;
    const response = yield call(requests.getRequest, url, {});
    yield put({
      type: loginActions.GET_USER_PROFILE_SUCCESS,
      payload: response,
    });

    setUserInfo(response);

    callback?.();
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put({
      type: loginActions.GET_USER_PROFILE_ERROR,
    });
  }
}

export function* watchLoginUser() {
  yield takeLeading(loginActions.LOGIN, loginUser);
  yield takeLeading(loginActions.LOGOUT, logoutUser);
  yield takeLatest(loginActions.GET_USER_PROFILE, getUserProfileSaga);
}

export default function* rootSaga() {
  yield all([fork(watchLoginUser)]);
}
